import { TechFetchSearch } from 'wisestep-api';

export default {
  allAny: 'Any',
  specializedArea: '',
  specializedSkill: '',
  stateCodes: '',
  relocation: '',
  domainExposure: '',
  workAuthorization: 'US Citizen,Green Card,H1B Work Permit',
  preferredEmployment: 'Corp-Corp,W2-Contract,W2-Permanent,1099-Contract,H1B Transfer',
  degree: '',
  experience: '',
  usExperience: '',
  resultsPerPage: 50,
  pageNumber: 1,
  sortBy: '',
  search: '',
  workspaceId: '',
  accessToken: '',
  searchId: '',
  resumesPostedWithinDays: '60',
  workAuthorizations: ['US Citizen', 'Green Card', 'H1B Work Permit'],
  domainExposures: [],
  degrees: [],
  usExperiences: [],
  experiences: [],
  preferredEmploymentTypes: [
    'Corp-Corp',
    'W2-Contract',
    'W2-Permanent',
    '1099-Contract',
    'H1B Transfer',
  ],
} as TechFetchSearch;

export const States = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District Of Columbia': 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT ',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
};
